import { Box } from "./Box";

export const Kbd = ({ children }: { children: string }) => (
  <kbd className="inline-flex items-center justify-center h-8 min-w-8 px-2 bg-gray-soft rounded text-base">
    {children}
  </kbd>
);

export const KbdSequence = ({ keys }: { keys: string[] }) => (
  <Box alignItems={"center"}>
    {keys.map((k, i) => (
      <Kbd key={i}>{k}</Kbd>
    ))}
  </Box>
);
